module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ujxj2n/tc-custom/9781426801068.jpg?1740446409145",
      "alt": "This image is the cover for the book Billionaire's Scandalous Marriage"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Billionaire's Scandalous Marriage\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A socialite with a ticking biological clock marries a billionaire for convenience and falls in love in this sexy international romance.")]), _c('br'), _c('br'), _vm._v("Damien Wynter was as handsome and arrogant as sin. Heiress Charlotte didn’t need his dark, primitive sensuality in her life—until the man she’d planned to marry disappointed her, and Damien offered a challenge: let him wed her and get her pregnant!"), _c('br'), _c('br'), _vm._v("It was all about winning to Damien, but Charlotte wanted a baby, and if surrendering him meant she could win, too, why not accept his scandalous offer?"), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Emma Darcy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Initially a French/English teacher, Emma Darcy changed careers to computer programming before the happy demands of marriage and motherhood. Very much a people person, and always interested in relationships, she finds the world of romance fiction a thrilling one and the challenge of creating her own cast of characters very addictive.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0